import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import _ from 'lodash';
import {
    Loader,
    Money,
    Chevron,
    ModalNextProvider,
} from '@jutro/components';
import { ServiceManager } from '@jutro/services';
import { withAuthenticationContext } from 'gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import { PaymentComponent, Link, Currency as CurrencyField } from 'gw-components-platform-react';
import {
    TranslatorContext, withIntl, formatCurrency, LocaleContext, formatLongDate
} from '@jutro/locale';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import AutomaticPaymentPolicyAffectedValueIterableComponent from './AutomaticPaymentPolicyAffectedValueIterableComponent';
import metadata from './BillingAndPayment.metadata.json5';
import accountBillingStyles from './BillingAndPayment.module.scss';
import messages from '../Accounts.messages';
import makePaymentMessages from './MakePayment/MakePayment.messages';
import PaymentMethodComponent from '../../Components/PaymentMethodComponent/PaymentMethodComponent';

class AccountBillingAndPayment extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string
            }),
            billingData: PropTypes.shape({})
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
            location: PropTypes.shape({
                billingDataFromMakePayment: PropTypes.shape({}).isRequired
            }).isRequired
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired
    };

    state = {
        billingData: {},
        loaded: false,
        showInnerLoader: false,
        isSetupPayment: false,
        isSetupPaymentComplete: false,
        isDetailedScheduleOpen: false,
        noBillingData: false,
        xCenter: '',
        isEdit:false
    };

    localeService = ServiceManager.getService('locale-service');

    createVM = (model) => {
        const { viewModelService } = this.props;
        return viewModelService.create(model, 'bc', 'edge.capabilities.billing.dto.BillingInfoDTO');
    };

    getResponse = async () => {
        const {
            authHeader,
            fromAccountLanding: {
                accountDetailsData,
                accountDetailsData: { accountNumber },
                billingData
            },
            history: {
                location: { billingDataFromMakePayment }
            }
        } = this.props;
        const responseDataAccountBillingSummary = await
        GatewayBillingService.getAccountBillingSummary(
            accountNumber,
            authHeader
        ).catch(() => {
            this.setState({
                loaded: true,
                noBillingData: true
            });
        });
        const model = {};
        const billingInfoVM = this.createVM(model);
        billingInfoVM.paymentGroups = !_.isEmpty(responseDataAccountBillingSummary)
            ? responseDataAccountBillingSummary.paymentGroups
            : [];
        const { _xCenter } = billingInfoVM;
        if (billingDataFromMakePayment) {
            this.setState({
                billingData: billingDataFromMakePayment,
                loaded: true,
                xCenter: _xCenter
            });
        } else {
            const primaryPayerAddress = _.get(accountDetailsData, 'accountBillingSummary.primaryPayer.address', '').split(', ');
            const phoneNumberForPrimaryPayer = _.get(accountDetailsData, 'accountBillingSummary.primaryPayer.phoneNumber');
            if (phoneNumberForPrimaryPayer) {
                primaryPayerAddress.push(phoneNumberForPrimaryPayer);
            }
            this.setState({
                billingData: {
                    accountDetailsPrimaryPayerAddress: primaryPayerAddress,
                    getAccountDetails: accountDetailsData,
                    getAccountBillingData: billingData,
                    getAccountBillingDetails: _.isEmpty(responseDataAccountBillingSummary)
                        ? { paymentGroups: [] }
                        : responseDataAccountBillingSummary,
                    paymentGroup: {
                        relatedPolicies: []
                    }
                },
                loaded: true,
                xCenter: _xCenter
            });
        }
    };

    componentDidMount = () => {
        this.getResponse();
    };

    renderAccordionHeader = (isOpen) => {
        const translator = this.context;
        let accordionHeaderTitle = translator(messages.viewPaymentScheduleDetail);
        if (isOpen) {
            accordionHeaderTitle = translator(messages.hidePaymentScheduleDetail);
        }
        return (
            <React.Fragment>
                <Chevron
                    isOpen={isOpen}
                    align="left"
                    className={accountBillingStyles.chevronStyle}
                />
                <h5 className={accountBillingStyles.accordionTitle}>{accordionHeaderTitle}</h5>
            </React.Fragment>
        );
    };

    getAccountStatusIcon = (billingData) => {
        const accountBillingData = billingData.getAccountBillingData;
        let isDelinquent = false;
        if (!_.isEmpty(accountBillingData) && !_.isEmpty(accountBillingData.ownedPolicies)) {
            isDelinquent = accountBillingData.ownedPolicies.length > 0
                && _.filter(accountBillingData.ownedPolicies, {
                    isDelinquent: true
                }).length > 0;
        }
        if (!_.isEmpty(accountBillingData.unownedPolicies)) {
            isDelinquent = accountBillingData.unownedPolicies.length > 0
                && _.filter(accountBillingData.unownedPolicies, {
                    isDelinquent: true
                }).length > 0;
        }
        return isDelinquent ? 'mi-warning' : 'mi-check';
    };

    getAccountStatusClassname = (billingData) => {
        if (!_.isEmpty(billingData.getAccountDetails.accountBillingSummary)) {
            if (_.get(billingData, 'getAccountDetails.accountBillingSummary.isDelinquent')) {
                return 'accountBillingIcon accountBillingDelinquent';
            }
        }
        return 'accountBillingIcon accountBillingGoodStanding';
    };

    getAccountStatusText = (billingData) => {
        const translator = this.context;
        let statusText = translator(messages.inGoodStanding);

        if (!_.isEmpty(billingData.getAccountDetails.accountBillingSummary)) {
            if (_.get(billingData, 'getAccountDetails.accountBillingSummary.isDelinquent')) {
                statusText = translator(messages.delinquent);
            }
        }
        return statusText;
    };

    generateSetupPaymentOverrides = () => {
        const { billingData } = this.state;
        const relatedPoliciesPath = 'paymentGroup.relatedPolicies';
        const relatedPolicies = _.get(billingData, relatedPoliciesPath, []);

        const overrides = relatedPolicies.map((relatedPolicy, index) => {
            return {
                [`tabAutomaticPaymentsSetupInvoicePolicy${index}`]: {
                    value: <Link to={`/policies/${relatedPolicy}/summary`}>{relatedPolicy}</Link>
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    generateAutomaticBillingOverrides = () => {
        const translator = this.context;
        const { billingData } = this.state;
        const paymentGroupsPath = 'getAccountBillingDetails.paymentGroups';
        const paymentGroups = _.get(billingData, paymentGroupsPath, []);
        const invoiceSummaryPath = 'invoiceSummary';

        const overrides = paymentGroups.map((paymentGroup, index) => {
            const invoiceSummary = _.get(paymentGroup, invoiceSummaryPath);
            return {
                [`tabAutomaticHeaderTitle${index}`]: {
                    message: translator(messages.invoiceStream, {
                        periodicity: paymentGroup.displayName
                    })
                },
                [`tabAutomaticPaymentsPaymentInstrumentSummaryText${index}`]: {
                    value: paymentGroup.paymentInstrumentSummary
                        ? translator(messages.automaticPaymentsEnabled)
                        : translator(messages.automaticPaymentsNotEnabled)
                },
                [`tabAutomaticPaymentsPaymentInstrumentSummaryIconCheck${index}`]: {
                    visible: _.has(paymentGroup, 'paymentInstrumentSummary')
                },
                [`tabAutomaticPaymentsPaymentInstrumentSummarySetup${index}`]: {
                    // visible: !_.has(paymentGroup, 'paymentInstrumentSummary'),
                    visible: false, //Hide all time 
                    onClick: () => {
                        this.handleSetupAutomaticPayment(index,false);
                    }
                },
                [`tabAutomaticPaymentsPaymentInstrumentSummarySetupEdit${index}`]: {
                    visible: _.has(paymentGroup, 'paymentInstrumentSummary'),
                    onClick: () => {
                        this.handleSetupAutomaticPayment(index,true);
                    }
                },
                [`tablePaymentScheduleDetail${index}`]: {
                    data: paymentGroup.invoiceSummary
                },
                [`tabAutomaticPaymentNextDue${index}`]: {
                    label: this.getFirstUnpaidBillDueDate(invoiceSummary, 'label'),
                    value: this.getFirstUnpaidBillDueDate(invoiceSummary, 'value')
                },
                [`tabAutomaticPaymentPastDue${index}`]: {
                    label: this.getOverdueStatEarliestDue(invoiceSummary, 'label'),
                    value: this.getOverdueStatEarliestDue(invoiceSummary, 'value')
                },
                [`tabAutomaticPaymentTotalDue${index}`]: {
                    value: this.getInvoiceStreamTotalDue(invoiceSummary)
                },
                [`accordionPaymentScheduleDetailsSection${index}`]: {
                    header: this.renderAccordionHeader
                },
                [`tabAutomaticPaymentPolicyAffectedValuesComponent${index}`]: {
                    data: {
                        paymentGroup: paymentGroup,
                        policySummaries: billingData.getAccountDetails.policySummaries
                    }
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    getCell = (item, index, property) => {
        return item[property.id];
    };

    getPolicyLink = (item, index, property) => {
        return <Link to={`/policies/${item[property.id]}/summary`}>{item[property.id]}</Link>;
    };

    getFormattedDate = (item, index, property) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(item[property.id]), { year: 'numeric', month: 'short', day: 'numeric' });
    };

    renderFormattedCurrencyField = (item, index) => {
        return (
            <div className={accountBillingStyles.currencyContainer}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={item}
                    readOnly
                    hideLabel
                />
            </div>
        );
    };

    getFormattedCurrency = (item, index, property) => {
        return this.renderFormattedCurrencyField(item[property.id], index);
    };

    getFormattedCurrencyPaymentSchedule = (item, index, property) => {
        const { amount, currency } = item.breakdown[property.id];
        return this.renderFormattedCurrencyField({ amount, currency }, index);
    };

    getFormattedCurrencyCharges = (item) => {
        const { charges, taxes } = item.breakdown;
        return (
            <Money
                amount={charges.amount + taxes.amount}
                currency={charges.currency}
                showFractions
            />
        );
    };

    getBillStatus = (item, index, property) => {
        const translator = this.context;
        return translator(messages[item[property.id]]);
    };

    getAltBillingAccount = (item, index, property) => {
        return item[property.id] || '-';
    };

    getIsDelinquent = (item, index, property) => {
        const translator = this.context;
        const isDelinquent = item[property.id];
        if (isDelinquent) {
            return translator(messages.delinquent);
        }
        return translator(messages.inGoodStanding);
    };

    aggregateBilling = (invoiceSummary) => {
        if (invoiceSummary.length > 0) {
            let totalAmountDue = 0;
            let earliestDue = new Date(invoiceSummary[0].dueDate);
            _.each(invoiceSummary, (invoice) => {
                totalAmountDue += invoice.amountDue.amount;
                const newDueDate = new Date(invoice.dueDate);
                if (newDueDate.getTime() < earliestDue.getTime()) {
                    earliestDue = newDueDate;
                }
            });

            return {
                amountDue: {
                    amount: totalAmountDue,
                    currency: invoiceSummary[0].amountDue.currency
                },
                dueDate: earliestDue
            };
        }
        return null;
    };

    getFirstUnpaidBillDueDate = (invoiceSummary, returnType) => {
        const translator = this.context;
        const { intl } = this.props;
        const unpaidStat = _.minBy(
            _.filter(invoiceSummary, (invoice) => {
                return invoice.invoiceStatus === 'planned';
            }),
            (invoice) => {
                return new Date(invoice.eventDate).getTime();
            }
        );

        if (unpaidStat) {
            if (returnType === 'label') {
                return translator(messages.nextDueDate,
                    {
                        firstUnpaidBillDueDate: intl.formatDate(new Date(unpaidStat.eventDate), { year: 'numeric', month: 'short', day: 'numeric' })
                    });
            }

            return unpaidStat.amountDue;
        }

        if (returnType === 'label') {
            return translator(messages.nextDue);
        }
        return ({ amount: 0, currency: this.localeService.getDefaultCurrencyCode() });
    };

    getSetupPaymentNextPayment = (invoiceSummary) => {
        const translator = this.context;
        const { amount, currency } = this.getFirstUnpaidBillDueDate(invoiceSummary, 'value');
        const currencyAmount = formatCurrency(amount, currency, LocaleContext);
        return translator(
            messages.setupPaymentConfirmNextPayment,
            { currencyAmount: currencyAmount }
        );
    };

    getOverdueStatEarliestDue = (invoiceSummary, returnType) => {
        const translator = this.context;
        const { intl } = this.props;
        const overdueStatus = this.aggregateBilling(_.filter(invoiceSummary, (invoice) => { return invoice.invoiceStatus === 'due'; }));
        if (overdueStatus) {
            if (returnType === 'label') {
                return translator(messages.pastDueDate,
                    {
                        overdueStatEarliestDate: intl.formatDate(new Date(overdueStatus.dueDate), { year: 'numeric', month: 'short', day: 'numeric' })
                    });
            }
            return overdueStatus.amountDue;
        }

        if (returnType === 'label') {
            return translator(messages.pastDue);
        }
        return ({ amount: 0, currency: this.localeService.getDefaultCurrencyCode() });
    };

    getInvoiceStreamTotalDue = (invoiceSummary) => {
        const overdueStat = this.aggregateBilling(
            _.filter(invoiceSummary, (invoice) => {
                return invoice.invoiceStatus === 'due';
            })
        );
        const billedStat = this.aggregateBilling(
            _.filter(invoiceSummary, (invoice) => {
                return invoice.invoiceStatus === 'billed';
            })
        );
        const amountDue = {
            amount: 0,
            currency: this.localeService.getDefaultCurrencyCode()
        };
        if (overdueStat && billedStat) {
            amountDue.amount = overdueStat.amountDue.amount + billedStat.amountDue.amount;
            amountDue.currency = overdueStat.amountDue.currency;
        } else if (overdueStat) {
            amountDue.amount = overdueStat.amountDue.amount;
            amountDue.currency = overdueStat.amountDue.currency;
        } else if (billedStat) {
            amountDue.amount = billedStat.amountDue.amount;
            amountDue.currency = billedStat.amountDue.currency;
        }
        return amountDue;
    };

    handleMakeAPayment = () => {
        const { history } = this.props;
        const { billingData, xCenter } = this.state;
        return history.push({
            pathname: `/pay-invoices/billed/${billingData.getAccountDetails.accountNumber}`,
            state: {
                accountNumber: billingData.getAccountDetails.accountNumber,
                xCenter: xCenter,
                billingData
            }
        });
    };

    handleSetupAutomaticPayment = (invoiceStreamIndex,isEdit) => {
        const { billingData } = this.state;
        const {
            authHeader,
            fromAccountLanding: {
                accountDetailsData: { accountNumber }
            }
        } = this.props;
        const invoiceStream = billingData
            .getAccountBillingDetails.paymentGroups[invoiceStreamIndex];

        this.setState({ showInnerLoader: true, isSetupPayment: true, isEdit: isEdit});
        GatewayBillingService.getPaymentGroupPaymentInformation(
            accountNumber, invoiceStream.internalId, authHeader
        ).then(
            (responseData) => {
                billingData.paymentGroup = responseData;
                this.setState({
                    billingData,
                    showInnerLoader: false
                });
            }
        );
    };

    handleCancelSetupPayment = () => {
        this.setState({ showInnerLoader: false, isSetupPayment: false });
    };

    handleReturnSetupPayment = () => {
        const { billingData } = this.state;
        this.setState({ showInnerLoader: true });
        const {
            authHeader,
            fromAccountLanding: {
                accountDetailsData: { accountNumber }
            }
        } = this.props;
        GatewayBillingService.getAccountBillingSummary(accountNumber, authHeader).then(
            (response) => {
                billingData.getAccountBillingDetails = _.isEmpty(response)
                    ? { paymentGroups: [] }
                    : response;
                this.setState({
                    billingData,
                    showInnerLoader: false,
                    isSetupPayment: false,
                    isSetupPaymentComplete: false
                });
            }
        );
    };

    handleConfirmSetupPayment = (paymentData, paymentMethod) => {
        const {
            authHeader,
            fromAccountLanding: {
                accountDetailsData: { accountNumber }
            }
        } = this.props;
        const { billingData } = this.state;
        const invoiceStreamInternalId = billingData.paymentGroup.internalId;

        const paymentInstrument = {};
        let publicID = '';
         publicID = _.get(paymentData, 'publicID.value');
        if(publicID) {
            paymentInstrument.publicID = publicID;
        }
        
        paymentInstrument.paymentMethod = paymentData.paymentMethod.value.code;
        paymentInstrument.overrideDayOfMonth = paymentData.overrideDayOfMonth.value;
        
        if (paymentMethod === 'ach') {
            const bankAccountData = {
                bankAccountType: _.get(paymentData, 'bankAccountData.bankAccountType.value.code'),
                bankAccountNumber: _.get(paymentData, 'bankAccountData.bankAccountNumber.value'),
                bankABANumber: _.get(paymentData, 'bankAccountData.bankABANumber.value'),
                bankName: _.get(paymentData, 'bankAccountData.bankName.value'),
                institutionNumber: _.get(paymentData, 'bankAccountData.institutionNumber.value')
            };

            // paymentInstrument.paymentMethod = paymentMethod;
            paymentInstrument.bankAccountData = bankAccountData;
            paymentInstrument.creditCardData = null;
        } else if (paymentMethod === 'preauthorizedCC_EY') {
            const creditBankAccountData = {
                 creditCardIssuer: _.get(paymentData, 'creditCardData.creditCardIssuer.value.code'),
                //creditCardNumber: _.get(paymentData, 'creditCardData.creditCardNumber.value'),
                creditCardExpDate: _.get(paymentData, 'creditCardData.creditCardExpDate.value'),
                creditCardHolderName_EY: _.get(paymentData, 'creditCardData.creditCardHolderName_EY.value'),
                token_EY: _.get(paymentData, 'creditCardData.token_EY.value'),
                modeOfReceiving_EY: _.get(paymentData, 'creditCardData.modeOfReceiving_EY.value.code')
               
            };

            // paymentInstrument.paymentMethod = 'creditcard';
            paymentInstrument.creditCardData = creditBankAccountData;
            paymentInstrument.bankAccountData = null;
        }
    

        this.setState({ showInnerLoader: true });
        GatewayBillingService.setPaymentGroupPaymentInformation(
            accountNumber,
            invoiceStreamInternalId,
            paymentInstrument,
            authHeader
        )
            .then(() => {
                this.setState({
                    showInnerLoader: false,
                    isSetupPayment: false,
                    isSetupPaymentComplete: true
                });
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: messages.setupPaymentFailed,
                    message: messages.setupPaymentFailedSorry,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
    };

    getAutomaticPaymentScheduleTitle = () => {
        const translator = this.context;
        const { billingData } = this.state;
        return translator(messages.setupAutomaticPaymentSchedule,
            { displayName: billingData.paymentGroup.displayName });
    };

    getAutomaticPaymentScheduleMessage = () => {
        const translator = this.context;
        const { billingData } = this.state;
        const {
            paymentGroup: { displayName = '' }
        } = billingData;
        const displayValue = displayName.replace(/[\d()]/g, '').trim();
        let formattedDate = billingData.paymentGroup.scheduleTerms
            ? billingData.paymentGroup.scheduleTerms[0].startDate
            : '';
        formattedDate = formatLongDate(new Date(formattedDate.split('T')[0]));
        return (
            <>
                <span>
                    {translator(messages.scheduleTermTitle)}
                    &nbsp;
                </span>
                <strong>
                    {translator(messages.scheduleTermDescription, {
                        periodicity: displayValue,
                        startDate: formattedDate
                    })}
                </strong>
            </>
        );
    };

    getAutomaticPaymentScheduleDueDate = () => {
        const translator = this.context;
        const { billingData } = this.state;
        const formattedDate = billingData.paymentGroup.scheduleTerms
            ? billingData.paymentGroup.scheduleTerms[0].startDate
            : '';
        const dueDate = formatLongDate(new Date(formattedDate.split('T')[0]));
        return translator(messages.setupPaymentConfirmDue, { dueDate: dueDate });
    };

    getPaymentConfirmPhone = () => {
        const translator = this.context;
        return translator(messages.setupPaymentConfirmPhone, { supportPhone: config.supportPhone });
    };

    getTotalPremium = () => {
        const { billingData } = this.state;
        let totalPremium = 0;
        _.each(billingData.paymentGroup.invoiceSummary, (invoice) => {
            totalPremium += invoice.amountDue.amount;
        });
        return totalPremium;
    };

    handleTogglePaymentSchedule = () => {
        const { isDetailedScheduleOpen } = this.state;
        this.setState({
            isDetailedScheduleOpen: !isDetailedScheduleOpen
        });
    };

    onCancelPayment = () => {
        const {
            fromAccountLanding: {
                accountDetailsData: { accountNumber }
            },
            history
        } = this.props;
        const nextPath = `/accounts/${accountNumber}/billingAndPayment`;
        history.push({
            pathname: nextPath,
            ...this.props,
            accountDetailsData: {
                accountNumber: accountNumber
            }
        });
    };

    render() {
        const translator = this.context;
        const {
            authHeader,checkPermission
                   } = this.props;
        const {
            billingData,
            loaded,
            showInnerLoader,
            isSetupPayment,
            isSetupPaymentComplete,
            isDetailedScheduleOpen,
            noBillingData,
            xCenter,
            isEdit
        } = this.state;
        if (!loaded) {
            return (
                <Loader loaded={loaded} />
            );
        }
        if (_.isEmpty(billingData)) {
            return true;
        }

        const overrideProps = {
            billingPageAccountStatusIcon: {
                icon: this.getAccountStatusIcon(billingData),
                className: this.getAccountStatusClassname(billingData)
            },
            billingPageAccountStatus: {
                value: this.getAccountStatusText(billingData)
            },
            tabBillingMakeAPayment: {
                visible:
                    _.get(billingData, 'getAccountBillingData.totalDue')
                    && _.get(billingData, 'getAccountBillingData.totalDue.amount') > 0
            },
            tabBillingPoliciesOwnedTable: {
                data: billingData.getAccountBillingData.ownedPolicies
            },
            tabBillingPoliciesUnownedTable: {
                data: billingData.getAccountBillingData.unownedPolicies
            },
            tabAutomaticPaymentsContent: {
                visible: !isSetupPayment && !isSetupPaymentComplete && !noBillingData,
                data: billingData.getAccountBillingDetails.paymentGroups
            },
            setupAutomaticPaymenetsSetup: {
                visible: isSetupPayment && !showInnerLoader
            },
            setupAutomaticPaymentsSuccess: {
                visible: isSetupPaymentComplete && !showInnerLoader
            },
            setupPaymentLoader: {
                visible: showInnerLoader,
                loaded: !showInnerLoader
            },
            tabAutomaticPaymentsScheduleTitle: {
                message: this.getAutomaticPaymentScheduleTitle()
            },
            paymentScheduleMessageLabel: {
                content: this.getAutomaticPaymentScheduleMessage()
            },
            paymentSchedulePremium: {
                value: this.getTotalPremium()
            },
            paymentScheduleDetailToggle: {
                icon: isDetailedScheduleOpen ? 'caret-up' : 'caret-down',
                message: isDetailedScheduleOpen
                    ? translator(messages.hideDetailedSchedule)
                    : translator(messages.showDetailedSchedule)
            },
            detailedScheduleContainer: {
                visible: isDetailedScheduleOpen
            },
            detailedScheduleTable: {
                data: billingData.paymentGroup.invoiceSummary
            },
            paymentSetupSuccessNextPayment: {
                value: this.getSetupPaymentNextPayment(billingData.paymentGroup.invoiceSummary)
            },
            paymentSetupSuccessDue: {
                value: this.getAutomaticPaymentScheduleDueDate()
            },
            paymentSetupSuccessPhone: {
                message: this.getPaymentConfirmPhone()
            },
            noBillingData: {
                visible: noBillingData
            },
            tabBillingContent: {
                visible: !noBillingData
            },
            paymentPageComponent: {
                xCenter: xCenter,
                isSetupPayment: isSetupPayment,
                nextLabel: !isEdit
                    ? translator(messages.setupPaymentConfirm)
                    : translator(messages.update),
                billingData: billingData,
                authHeader:authHeader,
                isEdit:isEdit

            },
            tabAutomaticPayments: {
                visible : checkPermission('accountbilling')
            },
            ...this.generateAutomaticBillingOverrides(),
            ...this.generateSetupPaymentOverrides()
        };

        const resolvers = {
            resolveClassNameMap: accountBillingStyles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getPolicyLink: this.getPolicyLink,
                getFormattedDate: this.getFormattedDate,
                getFormattedCurrency: this.getFormattedCurrency,
                getAltBillingAccount: this.getAltBillingAccount,
                getIsDelinquent: this.getIsDelinquent,
                getBillStatus: this.getBillStatus,
                getFormattedCurrencyPaymentSchedule: this.getFormattedCurrencyPaymentSchedule,
                handleMakeAPayment: this.handleMakeAPayment,
                handleTogglePaymentSchedule: this.handleTogglePaymentSchedule,
                getFormattedCurrencyCharges: this.getFormattedCurrencyCharges,
                handleCancelSetupPayment: this.handleCancelSetupPayment,
                handleConfirmSetupPayment: this.handleConfirmSetupPayment,
                handleReturnSetupPayment: this.handleReturnSetupPayment,
                onCancelPayment: this.handleCancelSetupPayment
            },
            resolveComponentMap: {
                paymentpagecomponent: PaymentMethodComponent,
                // paymentpagecomponent: PaymentComponent,
                automaticpaymentpolicyaffectedvalueiterablecomponent:
                    AutomaticPaymentPolicyAffectedValueIterableComponent
            }
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, billingData, id, path, overrideProps);
        };

        return (
            <div className={accountBillingStyles.accountbilling}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={billingData}
                    overrideProps={overrideProps}
                    resolveValue={readValue}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </div>
        );
    }
}

export const AccountBillingAndPaymentComponent = AccountBillingAndPayment;
export default withIntl(withViewModelService(withAuthenticationContext(AccountBillingAndPayment)));
